export default {
      id: "bluetooth-station-usage",
      viewBox: "0 0 31 35",
      url: __webpack_public_path__ + "img/icons.svg#bluetooth-station",
      toString: function () {
        return this.url;
      }
    }